import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugwv3cgvqe: FaireProductEntity = {
  token: "p_ugwv3cgvqe",
  type: "product",
  name: "Love You Lg Charm Bowl (Boxed)",
  brandToken: "b_4ff718f6",
  brandName: "Basic Spirit",
  imageUrl:
    "https://cdn.faire.com/fastly/7986bdd97af3f29cf82b2256f887fee1a21775bd9b685804aeb8063a8d921173.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c25778dbe8f44effa7f72348a0669543d82d1f146a29164cc4955418bd22b122.webp",
  ],
  priceDollars: 11.64,
  description:
    'This exquisite heart-shaped dish, crafted from high-quality pewter, features the heartfelt inscription "Love You," making it an ideal gift for expressing affection. Elegantly boxed, it serves as a charming decorative piece or a functional bowl for small treasures, perfect for any occasion that celebrates love and connection.\nApprox piece 2.25" in diameter.\nComes in a gift box w/ pewter decorative piece Approx 3" x 3" x .75".\nHandmade By The Sea!\n10% Of profits fund charitable organizations. ',
  tags: [],
  msrpDollars: 23.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:51.511Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
